interface Props<T> {
  object: any;
  values: (keyof T | undefined)[];
}

export function getValuesFromObject<T>({ object, values }: Props<T>): T {
  const result = {} as T;

  values.forEach(value => {
    if (!value) return;
    const fieldValue = object?.[value];
    const isEmpty =
      fieldValue === undefined ||
      fieldValue === null ||
      (typeof fieldValue === "string" && fieldValue.trim() === "") ||
      (Array.isArray(fieldValue) && fieldValue.length === 0);
    result[value] = isEmpty ? null : fieldValue;
  });

  return result;
}
